import i18next from 'i18next';
import { Link } from 'react-router-dom';

import DroneReport from '@/assets/drone-report.svg?react';
import { buttonVariants } from '@/components/ui/button';

const GoodJobMarine = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <h1 className="text-2xl pt-8 pb-1">{i18next.t('good_job_marine.title')}</h1>
      <p className="text-base text-muted-foreground pb-8">{i18next.t('good_job_marine.subtitle')}</p>
      <DroneReport className="pb-8" />
      <Link to="/mission-reports/new" className={buttonVariants({ variant: 'secondary' })}>
        {i18next.t('good_job_marine.add_new_report')}
      </Link>
    </div>
  );
};

export default GoodJobMarine;
